import { observer } from 'mobx-react';
import React from 'react';
import { SidebarStore } from '../SidebarStore';
import { CollapsibleMenu } from '../CollapsibleMenu';
import { TreeComponent } from '../menu/TreeComponent';
import Swal from 'sweetalert2'

@observer
export class SidebarTeacher extends React.Component<{ store: SidebarStore }>{
    render() {
        const store = this.props.store;
        const fullName = store.userStatus.user?.FirstName + ' ' + store.userStatus.user?.LastName;
        const description = store.userStatus.user?.Teacher?.Description;
        const email = store.userStatus.user?.Email;
        const tzOffsetMinutes = (store.userStatus.user?.TimeZone?.UtcOffsetMinutes ?? 0) / 60;
        const tt = this.formatTimezoneOffset(tzOffsetMinutes);
        const tzName = store.userStatus.user?.TimeZone?.Name + ` (UTC ${tt})`;
        const teacherMenu = store.teacherMenu
        
        teacherMenu.root.children = teacherMenu.root.children.filter(item => item.data.label !== 'Lessons')

        return (
            <div className="teacher-sidebar">
                <div className="teacherMenu">
                    <div className="teacherAvatar">
                        <i className="far fa-user-circle"></i>
                    </div>
                    <div className="teacherName">
                        <h4>{fullName}</h4>
                        <a href="#" onClick={this.onClickNotImplemented}>Edit Profile</a>
                        <p>{description}</p>
                        <span><i className="fas fa-map-marker-alt"></i> {tzName}</span>
                        <span>{email}</span>
                    </div>
                    <div className="teacherStats">
                        <ul>
                            <li>
                                <span><i className="fas fa-user-friends"></i></span>
                                <p>Students</p>
                                <span>123</span>
                            </li>
                            <li>
                                <span><i className="fas fa-chalkboard-teacher"></i></span>
                                <p>Lessons</p>
                                <span>1234</span>
                            </li>
                        </ul>
                    </div>
                    
                </div>
                <CollapsibleMenu label="Teacher menu">
                    <TreeComponent tree={teacherMenu} />
                </CollapsibleMenu>
            </div>
        );
    }

    onClickNotImplemented() {
        Swal.fire({ icon: 'info', text: 'Not implemented' });
    }

    formatTimezoneOffset(minutes: number): string {
        var date = new Date(0);
        date.setMinutes(Math.abs(minutes));
        var timeString = date.toISOString().substr(14, 5);
        var sign = minutes >= 0 ? '+' : '-';
        return sign + timeString;
    }
}